import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { CustomCartService } from '../../services/custom-cart.service'

/** Pass untouched request through to the next request handler. */
@Injectable()
export class CustomInterceptor implements HttpInterceptor {
  constructor(private customCartService: CustomCartService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const UomCode: string = this.customCartService.getUomCode()
    if (UomCode && UomCode.length > 0 && req.method === 'POST' && req.url.includes('/orgUsers/current/carts/')) {
      const newReq = req.clone({
        setParams: {
          UOM: UomCode
        }
      })
      return next.handle(newReq)
    }
    return next.handle(req)
  }
}
